import actionsDepartment from "./actions";

export default {
  namespaced: true,
  actions: actionsDepartment,
};
